import { render, staticRenderFns } from "./SimulateUserModal.vue?vue&type=template&id=64a922b5"
import script from "./SimulateUserModal.vue?vue&type=script&lang=js"
export * from "./SimulateUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports